import { getCells } from 'actions/orderActions';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { AppDispatch, RootState } from 'store/configureStore';
import { Cell } from '@m4a3/api-client';

  interface CellInformationListProps {
      readonly cells: Cell[];
      readonly getCells: () => void;
  }
   function CellInformationList ({
      cells,
      getCells,
   }: CellInformationListProps) {
      useEffect(() => {
      getCells()
      }, []);
 
      return (
          <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h2 className="text-2xl font-semibold leading-6 text-gray-900">Cell Information List</h2>
              <p className="mt-2 text-sm text-gray-700">
                A list of all the cells including their ID and Name.
              </p>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                        ID
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Cell Type
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Cell Status 
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Availability Mode
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {cells?.map((cell) => (
                      <tr key={cell.id}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{cell.id}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{cell.displayName}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{cell.cellType}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{cell.cellStatus}</td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{cell.availabilityMode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div> 
        </div>
      );
    }
    const mapStateToProps = (state: RootState) => ({
      cells: state.orders.cells
    });
    const mapDispatchToProps = (dispatch: AppDispatch) => ({
      getCells: () => getCells()(dispatch)
    });
    export default connect(
      mapStateToProps,
      mapDispatchToProps
    )(CellInformationList);